import { createApiRef } from '@backstage/core-plugin-api';
import {
  Announcement,
  CreateAnnouncementInput,
  UpdateAnnouncementInput,
} from '@internal/backstage-plugin-announcement-common';

export interface Permissions {
  read: boolean;
  create: boolean;
  update: boolean;
  delete: boolean;
}

export interface AnnouncementApi {
  isAuthenticated(): Promise<boolean>;
  checkPermissions(): Promise<Permissions>;
  fetchPublicAnnouncements(): Promise<Announcement[]>;
  fetchActiveAnnouncements(): Promise<Announcement[]>;
  fetchAnnouncements(): Promise<Announcement[]>;
  createAnnouncement(input: CreateAnnouncementInput): Promise<Announcement>;
  updateAnnouncement(
    id: string,
    input: UpdateAnnouncementInput,
  ): Promise<Announcement>;
  deleteAnnouncement(id: string): Promise<void>;
}

export const announcementApiRef = createApiRef<AnnouncementApi>({
  id: 'plugin.announcement.service',
});
